<div class="profile-individual-customer-dialog">
  <div class="profile-individual-customer-dialog__loading" *ngIf="submitLoading">
    <div class="ui-loader ui-loader__page-dark"></div>
  </div>
  <div [class.profile-individual-customer-dialog__dimmed]="submitLoading">
    <p class="txt-caption profile-individual-customer-dialog__global-error" *ngIf="globalError">{{ globalError }}</p>
    <form [formGroup]="form" novalidate (ngSubmit)="submit()">
      <div class="profile-individual-customer-dialog__type-switcher mb-3" role="radiogroup" aria-label="Тип регистрации заказчика">
        <ng-container *ngFor="let t of CustomerTypes">
          <input
            type="radio"
            class="profile-individual-customer-dialog__type-input"
            name="customerType"
            [id]="'profileCustomerType-' + t.id"
            [value]="t.id"
            formControlName="customerType" />
          <label class="profile-individual-customer-dialog__type-label" [for]="'profileCustomerType-' + t.id">
            <span>{{ t.label }}</span>
          </label>
        </ng-container>
      </div>

      <div class="profile-individual-customer-dialog__row">
        <div class="profile-individual-customer-dialog__cell">
          <div class="ui-input__placeholder">
            <p *ngIf="customerType === 'individual'">Имя</p>
            <p *ngIf="customerType === 'venue'">Имя представителя</p>
          </div>
          <div class="ui-input ui-input__text">
            <input
              type="text"
              formControlName="name"
              [placeholder]="customerType === 'individual' ? 'Как к вам обращаться' : 'Имя представителя'"
              maxlength="200" />
          </div>
        </div>
        <div class="profile-individual-customer-dialog__cell">
          <div class="ui-input__placeholder">
            <p>Город</p>
            <span class="require">*</span>
          </div>
          <p-dropdown
            formControlName="cityId"
            [options]="Cities"
            optionLabel="name"
            optionValue="id"
            placeholder="Выберите город"
            [filter]="true"
            filterPlaceholder="Поиск города..."
            styleClass="p-dropdown__bulletins"
            emptyFilterMessage="Ничего не нашли..."
            [class.error]="form.get('cityId')?.invalid && (form.get('cityId')?.touched || formSubmitted)">
          </p-dropdown>
          <p class="error-holder" *ngIf="form.get('cityId')?.invalid && (form.get('cityId')?.touched || formSubmitted)">Выберите город</p>
        </div>
      </div>

      <div class="profile-individual-customer-dialog__row" *ngIf="customerType === 'venue'">
        <div class="profile-individual-customer-dialog__cell">
          <div class="ui-input__placeholder">
            <p>Публичный телефон заведения</p>
            <span class="require">*</span>
          </div>
          <div class="ui-input ui-input__text" [class.error]="(!phoneValid || form.get('phone')?.invalid) && (form.get('phone')?.touched || formSubmitted)">
            <input
              type="text"
              formControlName="phone"
              placeholder="+7 (911) 111-11-11"
              mask="+0 (000) 000-00-00"
              (input)="onMaskPhone($event)"
              (blur)="form.get('phone')?.markAsTouched()"
              autocomplete="tel" />
          </div>
          <p class="error-holder" *ngIf="(!phoneValid || form.get('phone')?.invalid) && (form.get('phone')?.touched || formSubmitted)">Введите номер в формате +7</p>
        </div>
        <div class="profile-individual-customer-dialog__cell">
          <div class="ui-input__placeholder">
            <p>Мессенджеры, привязанные к телефону</p>
          </div>
          <div class="profile-individual-customer-dialog__messengers"
            [ngClass]="messengerClickEnabled ? '' : 'disabled'">
            <div class="grid align-items-center">
              <div class="col-auto">
                <span
                  class="mr-icon mr-icon-telegram-color"
                  (click)="onSetMessengerValue('hasTelegram')"
                  [class.selected]="onGetMessengerStatus('hasTelegram')"
                  role="button"
                  tabindex="0"
                  (keydown.enter)="onSetMessengerValue('hasTelegram')"
                  (keydown.space)="$event.preventDefault(); onSetMessengerValue('hasTelegram')"
                  title="Telegram">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </span>
              </div>
              <div class="col-auto">
                <span
                  class="mr-icon mr-icon-max-color"
                  (click)="onSetMessengerValue('hasMax')"
                  [class.selected]="onGetMessengerStatus('hasMax')"
                  role="button"
                  tabindex="0"
                  (keydown.enter)="onSetMessengerValue('hasMax')"
                  (keydown.space)="$event.preventDefault(); onSetMessengerValue('hasMax')"
                  title="MAX">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="customerType === 'venue'">
        <app-venue-customer-profile-fields
          [form]="form"
          [genres]="Genres"
          layout="dialog">
        </app-venue-customer-profile-fields>
      </ng-container>

      <div class="profile-individual-customer-dialog__social-head mt-2 mb-2">
        <p class="ui-input__placeholder">Соцсети <span class="require">*</span></p>
      </div>
      <div class="profile-individual-customer-dialog__social-list" formArrayName="socialLinks">
        <div
          class="profile-individual-customer-dialog__row mb-2"
          *ngFor="let row of socialLinksArray.controls; let i = index; trackBy: trackByIndex"
          [formGroupName]="i">
          <div class="profile-individual-customer-dialog__cell">
            <p-dropdown
              formControlName="platform"
              [options]="SocialPlatforms"
              optionLabel="name"
              optionValue="value"
              placeholder="Площадка"
              styleClass="p-dropdown__bulletins w-full">
            </p-dropdown>
          </div>
          <div class="profile-individual-customer-dialog__cell">
            <div class="ui-input ui-input__text">
              <input type="text" formControlName="url" placeholder="https://..." />
            </div>
          </div>
        </div>
      </div>
      <div class="profile-individual-customer-dialog__social-link-wrap mt-1 mb-2">
        <a class="profile-individual-customer-dialog__social-link" role="button" tabindex="0"
          (click)="addSocialLink()"
          (keydown.enter)="addSocialLink()"
          (keydown.space)="$event.preventDefault(); addSocialLink()">+ Добавить ссылку</a>
        <a
          class="profile-individual-customer-dialog__social-link profile-individual-customer-dialog__social-link--remove ml-3"
          role="button"
          tabindex="0"
          (click)="removeSocialLink(socialLinksArray.length - 1)"
          (keydown.enter)="removeSocialLink(socialLinksArray.length - 1)"
          (keydown.space)="$event.preventDefault(); removeSocialLink(socialLinksArray.length - 1)"
          *ngIf="socialLinksArray.length > 1">Удалить последнюю</a>
      </div>

      <ng-container *ngIf="customerType === 'venue'">
        <app-venue-customer-facilities-fields [form]="form" layout="dialog">
        </app-venue-customer-facilities-fields>
      </ng-container>

      <div class="grid justify-content-end mt-4 pt-2">
        <div class="col-auto pr-2">
          <button type="button" class="ui-buttons ui-buttons__light-large" (click)="onCancel()">Отмена</button>
        </div>
        <div class="col-auto">
          <button type="submit" class="ui-buttons ui-buttons__blue-large" [disabled]="submitLoading">Сохранить</button>
        </div>
      </div>
    </form>
  </div>
</div>
